module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/AtticatCalculator-a014f95f3c5936371ab3d9479a71c01b.png";